var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-jsoneditor',{attrs:{"value":_vm.getProp('value', ''),"options":_vm.getProp('options'),"height":_vm.getProp('height'),"plus":_vm.getProp('plus')},on:{"error":_vm.handleError,"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }